import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Loader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmark, faBuildingColumns } from '@fortawesome/free-solid-svg-icons';
import { getAuth } from 'firebase/auth';


const NotFound = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleLogin = () => {
        navigate('/login');
    };

    
    return (
        <>
            <div className="loader-overlay">
                <div className="transaction-loader">
                    <FontAwesomeIcon icon={faBuildingColumns} className="bank-icon left-bank" />
                    <div className="zebra-path" />
                    <FontAwesomeIcon icon={faLandmark} className="bank-icon right-bank" />
                </div>
                <div className="text-container">
                    <p className="not-found-text">Page Not Found</p>
                    {!isAuthenticated && (
                        <>
                            <p className="auth-warning">
                                You should login for full access.
                            </p>
                            <button className="login-btn" onClick={handleLogin}>
                                Login
                            </button>
                        </>
                    )}
                    <button className="go-back-btn" onClick={handleGoBack}>
                        Go Back
                    </button>
                </div>
            </div>
        </>
    );
};

export default NotFound;
